import {Map} from "immutable";
import {createRequestTypes, createSubmitRequestTypes} from "./helpers";

export const LOAD_AVAILABILITY = createRequestTypes("SHIPPING:LOAD_AVAILABILITY");
export const REQUEST_SET_AVAILABILITY = "SHIPPING:REQUEST_SET_AVAILABILITY";
export const SET_AVAILABILITY = createSubmitRequestTypes("SHIPPING:SET_AVAILABILITY")

export const requestSetAvailability = (data) => ({ type: REQUEST_SET_AVAILABILITY, data });
export const setAvailability = (data) => ({ type: SET_AVAILABILITY.SUBMIT, data });
export const setAvailabilitySubmitting = (data) => ({ type: SET_AVAILABILITY.SUBMITTING, data });
export const setAvailabilitySuccess = (data) => ({ type: SET_AVAILABILITY.SUCCESS, data });
export const setAvailabilityFailed = (data) => ({ type: SET_AVAILABILITY.FAILED, data });
export const cancelSetAvailability = () => ({ type: SET_AVAILABILITY.CANCEL });

export const HANDLE_INCOMING_EVENT = "SHIPPING:HANDLE_INCOMING_EVENT";
export const handleIncomingShippingEvent = (event, payload) => ({ type: HANDLE_INCOMING_EVENT, event, payload });

export const SET_AVAILABILITY_FILTER = "SHIPPING:SET_AVAILABILITY_FILTER";

export const LOAD_AVAILABILITY_FOR_COUNTRY = createRequestTypes("SHIPPING:LOAD_AVAILABILITY_FOR_COUNTRY");
export const LOAD_AVAILABILITY_FOR_US_STATE = createRequestTypes("SHIPPING:LOAD_AVAILABILITY_FOR_US_STATE");
export const loadAvailabilityForCountry = (country) => ({ type: LOAD_AVAILABILITY_FOR_COUNTRY.LOAD, country });
export const loadAvailabilityForUSState = (state) => ({ type: LOAD_AVAILABILITY_FOR_US_STATE.LOAD, state });

export const REQUEST_ASSIGN_WAREHOUSE_TO_LOCATION = "SHIPPING:REQUEST_ASSIGN_WAREHOUSE_TO_LOCATION";
export const ASSIGN_WAREHOUSE_TO_LOCATION = createSubmitRequestTypes("SHIPPING:ASSIGN_WAREHOUSE_TO_LOCATION");
export const requestAssignWarehouseToLocation = (kind, code, name, warehouseId) => ({type: REQUEST_ASSIGN_WAREHOUSE_TO_LOCATION, kind, code, name, warehouseId });
export const cancelAssignWarehouseToLocation = () => ({ type: ASSIGN_WAREHOUSE_TO_LOCATION.CANCEL });


// Couriers
export const REQUEST_ASSIGN_WAREHOUSE_COURIER = "SHIPPING:REQUEST_ASSIGN_WAREHOUSE_COURIER";
export const ASSIGN_WAREHOUSE_COURIER = createSubmitRequestTypes("SHIPPING:ASSIGN_WAREHOUSE_COURIER");
export const requestAssignWarehouseCourier = (id) => ({ type: REQUEST_ASSIGN_WAREHOUSE_COURIER, id });
export const cancelAssignWarehouseCourier = () => ({ type: ASSIGN_WAREHOUSE_COURIER.CANCEL });
export const assignWarehouseCourier = (data, formName) => ({ type: ASSIGN_WAREHOUSE_COURIER.SUBMIT, data, formName });

export const LOAD_COURIERS = createRequestTypes("SHIPPING:LOAD_COURIERS");
export const loadCouriers = (meta = Map()) => ({ type: LOAD_COURIERS.LOAD, meta });

export const REQUEST_CREATE_SHIPPING_ORDER = "SHIPPING:REQUEST_CREATE_SHIPPING_ORDER";
export const CREATE_SHIPPING_ORDER = createSubmitRequestTypes("SHIPPING:CREATE_SHIPPING_ORDER");
export const requestCreateShippingOrder = () => ({ type: REQUEST_CREATE_SHIPPING_ORDER });
export const cancelCreateShippingOrder = () => ({ type: CREATE_SHIPPING_ORDER.CANCEL });

export const REQUEST_CANCEL_SHIPPING_ORDER = "SHIPPING:REQUEST_CANCEL_SHIPPING_ORDER";
export const CANCEL_SHIPPING_ORDER = createSubmitRequestTypes("SHIPPING:CANCEL_SHIPPING_ORDER");
export const requestCancelShippingOrder = (orderId) => ({ type: REQUEST_CANCEL_SHIPPING_ORDER, orderId });
export const cancelCancelShippingOrder = () => ({ type: CANCEL_SHIPPING_ORDER.CANCEL });

export const REQUEST_CHANGE_DELIVERY_ADDRESS = "SHIPPING:REQUEST_CHANGE_DELIVERY_ADDRESS";
export const CHANGE_DELIVERY_ADDRESS = createSubmitRequestTypes("SHIPPING:CHANGE_DELIVERY_ADDRESS");
export const requestChangeDeliveryAddress = (orderId) => ({ type: REQUEST_CHANGE_DELIVERY_ADDRESS, orderId });
export const cancelChangeDeliveryAddress = () => ({ type: CHANGE_DELIVERY_ADDRESS.CANCEL });

export const REQUEST_SET_DELIVERY_INSTRUCTIONS = "SHIPPING:REQUEST_SET_DELIVERY_INSTRUCTIONS";
export const SET_DELIVERY_INSTRUCTIONS = createSubmitRequestTypes("SHIPPING:SET_DELIVERY_INSTRUCTIONS");
export const requestSetDeliveryInstructions = (orderId) => ({ type: REQUEST_SET_DELIVERY_INSTRUCTIONS, orderId });
export const cancelSetDeliveryInstructions = () => ({ type: SET_DELIVERY_INSTRUCTIONS.CANCEL });

export const REQUEST_ASSIGN_WAREHOUSE_TO_ORDER = "SHIPPING:REQUEST_ASSIGN_WAREHOUSE_TO_ORDER";
export const ASSIGN_WAREHOUSE_TO_ORDER = createSubmitRequestTypes("SHIPPING:ASSIGN_WAREHOUSE_TO_ORDER");
export const requestAssignWarehouseToOrder = (orderId) => ({ type: REQUEST_ASSIGN_WAREHOUSE_TO_ORDER, orderId });
export const cancelAssignWarehouseToOrder = () => ({ type: ASSIGN_WAREHOUSE_TO_ORDER.CANCEL });

export const REQUEST_CHANGE_WAREHOUSE_FOR_ORDER = "SHIPPING:REQUEST_CHANGE_WAREHOUSE_FOR_ORDER";
export const CHANGE_WAREHOUSE_FOR_ORDER = createSubmitRequestTypes("SHIPPING:CHANGE_WAREHOUSE_FOR_ORDER");
export const requestChangeWarehouseForOrder = (orderId) => ({ type: REQUEST_CHANGE_WAREHOUSE_FOR_ORDER, orderId });
export const cancelChangeWarehouseForOrder = () => ({ type: CHANGE_WAREHOUSE_FOR_ORDER.CANCEL });


export const REQUEST_ADD_PRODUCT_TO_SHIPPING_ORDER = "SHIPPING:REQUEST_ADD_PRODUCT_TO_SHIPPING_ORDER";
export const ADD_PRODUCT_TO_SHIPPING_ORDER = createSubmitRequestTypes("SHIPPING:ADD_PRODUCT_TO_SHIPPING_ORDER");
export const requestAddProductToShippingOrder = (orderId, shopId) => ({ type: REQUEST_ADD_PRODUCT_TO_SHIPPING_ORDER, orderId, shopId });
export const cancelAddProductToShippingOrder = () => ({ type: ADD_PRODUCT_TO_SHIPPING_ORDER.CANCEL });

export const REQUEST_REMOVE_PACKAGE_FROM_SHIPPING_ORDER = "SHIPPING:REQUEST_REMOVE_PACKAGE_FROM_SHIPPING_ORDER";
export const REMOVE_PACKAGE_FROM_SHIPPING_ORDER = createSubmitRequestTypes("SHIPPING:REMOVE_PACKAGE_FROM_SHIPPING_ORDER");
export const requestRemovePackageFromShippingOrder = (orderId, packageId) => ({ type: REQUEST_REMOVE_PACKAGE_FROM_SHIPPING_ORDER, orderId, packageId });
export const cancelRemovePackageFromShippingOrder = () => ({ type: REMOVE_PACKAGE_FROM_SHIPPING_ORDER.CANCEL });

// Replacement order
export const REQUEST_REPLACE_PACKAGES_FOR_SHIPPING_ORDER = "SHIPPING:REQUEST_REPLACE_PACKAGES_FOR_SHIPPING_ORDER";
export const REPLACE_PACKAGES_FOR_SHIPPING_ORDER = createSubmitRequestTypes("SHIPPING:REPLACE_PACKAGES_FOR_SHIPPING_ORDER");
export const requestReplacePackagesForShippingOrder = (orderId, packageIds) => ({ type: REQUEST_REPLACE_PACKAGES_FOR_SHIPPING_ORDER, orderId, packageIds });
export const cancelReplacePackagesForShippingOrder = () => ({ type: REPLACE_PACKAGES_FOR_SHIPPING_ORDER.CANCEL });

export const REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP = "SHIPPING:REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP";
export const CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP = createSubmitRequestTypes("SHIPPING:CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP");
export const requestChangePackageDeliveryStatusPickedUp = (orderId, trackingNr) => ({ type: REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP, orderId, trackingNr });
export const cancelChangePackageDeliveryStatusPickedUp = () => ({ type: CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP.CANCEL });

export const REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED = "SHIPPING:REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED";
export const CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED = createSubmitRequestTypes("SHIPPING:CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED");
export const requestChangePackageDeliveryStatusDelivered = (orderId, trackingNr) => ({ type: REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED, orderId, trackingNr });
export const cancelChangePackageDeliveryStatusDelivered = () => ({ type: CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED.CANCEL });

export const REQUEST_REQUEST_STOCK_RESERVATION = "SHIPPING:REQUEST_REQUEST_STOCK_RESERVATION";
export const REQUEST_STOCK_RESERVATION = createSubmitRequestTypes("SHIPPING:REQUEST_STOCK_RESERVATION");
export const requestRequestStockReservation = (orderId) => ({ type: REQUEST_REQUEST_STOCK_RESERVATION, orderId });
export const cancelRequestStockReservation = () => ({ type: REQUEST_STOCK_RESERVATION.CANCEL });

export const REQUEST_REQUEST_SHIPPING_QUOTE = "SHIPPING:REQUEST_REQUEST_SHIPPING_QUOTE";
export const REQUEST_SHIPPING_QUOTE = createSubmitRequestTypes("SHIPPING:REQUEST_SHIPPING_QUOTE");
export const requestRequestShippingQuote = (orderId) => ({ type: REQUEST_REQUEST_SHIPPING_QUOTE, orderId });
export const cancelRequestShippingQuote = () => ({ type: REQUEST_SHIPPING_QUOTE.CANCEL });

export const REQUEST_ACCEPT_SHIPPING_QUOTE = "SHIPPING:REQUEST_ACCEPT_SHIPPING_QUOTE";
export const ACCEPT_SHIPPING_QUOTE = createSubmitRequestTypes("SHIPPING:ACCEPT_SHIPPING_QUOTE");
export const requestAcceptShippingQuote = (orderId) => ({ type: REQUEST_ACCEPT_SHIPPING_QUOTE, orderId });
export const cancelAcceptShippingQuote = () => ({ type: ACCEPT_SHIPPING_QUOTE.CANCEL });

export const REQUEST_VOID_SHIPPING_QUOTE = "SHIPPING:REQUEST_VOID_SHIPPING_QUOTE";
export const VOID_SHIPPING_QUOTE = createSubmitRequestTypes("SHIPPING:VOID_SHIPPING_QUOTE");
export const requestVoidShippingQuote = (orderId) => ({ type: REQUEST_VOID_SHIPPING_QUOTE, orderId });
export const cancelVoidShippingQuote = () => ({ type: VOID_SHIPPING_QUOTE.CANCEL });

export const REQUEST_MARK_SHIPMENT_AS_COMPLIMENTARY = "SHIPPING:REQUEST_MARK_SHIPMENT_AS_COMPLIMENTARY";
export const MARK_SHIPMENT_AS_COMPLIMENTARY = createSubmitRequestTypes("SHIPPING:MARK_SHIPMENT_AS_COMPLIMENTARY");
export const requestMarkShipmentAsComplimentary = (orderId) => ({ type: REQUEST_MARK_SHIPMENT_AS_COMPLIMENTARY, orderId });
export const cancelMarkShipmentAsComplimentary = () => ({ type: MARK_SHIPMENT_AS_COMPLIMENTARY.CANCEL });

export const REQUEST_HOLD_SHIPMENT = "SHIPPING:REQUEST_HOLD_SHIPMENT";
export const HOLD_SHIPMENT = createSubmitRequestTypes("SHIPPING:HOLD_SHIPMENT");
export const requestHoldShipment = (orderId) => ({ type: REQUEST_HOLD_SHIPMENT, orderId });
export const cancelHoldShipment = () => ({ type: HOLD_SHIPMENT.CANCEL });

export const REQUEST_RELEASE_SHIPMENT_HOLD = "SHIPPING:REQUEST_RELEASE_SHIPMENT_HOLD";
export const RELEASE_SHIPMENT_HOLD = createSubmitRequestTypes("SHIPPING:RELEASE_SHIPMENT_HOLD");
export const requestReleaseShipmentHold = (orderId) => ({ type: REQUEST_RELEASE_SHIPMENT_HOLD, orderId });
export const cancelReleaseShipmentHold = () => ({ type: RELEASE_SHIPMENT_HOLD.CANCEL });

export const REQUEST_PROCESS_SHIPMENT = "SHIPPING:REQUEST_PROCESS_SHIPMENT";
export const PROCESS_SHIPMENT = createSubmitRequestTypes("SHIPPING:PROCESS_SHIPMENT");
export const requestProcessShipment = (orderId) => ({ type: REQUEST_PROCESS_SHIPMENT, orderId });
export const cancelProcessShipment = () => ({ type: PROCESS_SHIPMENT.CANCEL });

export const REQUEST_VIEW_EDI_MESSAGE_DATA = "SHIPPING:REQUEST_VIEW_EDI_MESSAGE_DATA";
export const VIEW_EDI_MESSAGE_DATA = createSubmitRequestTypes("SHIPPING:VIEW_EDI_MESSAGE_DATA");
export const requestViewEdiMessageData = (id) => ({ type: REQUEST_VIEW_EDI_MESSAGE_DATA, id });
export const cancelViewEdiMessageData = () => ({ type: VIEW_EDI_MESSAGE_DATA.CANCEL });

export const REQUEST_SCHEDULE_SHIPMENT = "SHIPPING:REQUEST_SCHEDULE_SHIPMENT";
export const SCHEDULE_SHIPMENT = createSubmitRequestTypes("SHIPPING:SCHEDULE_SHIPMENT");
export const requestScheduleShipment = (orderId) => ({ type: REQUEST_SCHEDULE_SHIPMENT, orderId });
export const cancelScheduleShipment = () => ({ type: SCHEDULE_SHIPMENT.CANCEL });

export const REQUEST_UNSCHEDULE_SHIPMENT = "SHIPPING:REQUEST_UNSCHEDULE_SHIPMENT";
export const UNSCHEDULE_SHIPMENT = createSubmitRequestTypes("SHIPPING:UNSCHEDULE_SHIPMENT");
export const requestUnscheduleShipment = (orderId) => ({ type: REQUEST_UNSCHEDULE_SHIPMENT, orderId });
export const cancelUnscheduleShipment = () => ({ type: UNSCHEDULE_SHIPMENT.CANCEL });


export function loadAvailability(meta = Map()) {
  return {
    type: LOAD_AVAILABILITY.LOAD,
    meta
  }
}

export function loadAvailabilityLoading() {
  return {
    type: LOAD_AVAILABILITY.LOADING
  }
}

export function loadAvailabilitySuccess(entities, result) {
  return {
    type: LOAD_AVAILABILITY.SUCCESS,
    entities, result
  }
}

export function loadAvailabilityFailed() {
  return {
    type: LOAD_AVAILABILITY.FAILED
  }
}

export function setAvailabilityFilter(filter) {
  return {
    type: SET_AVAILABILITY_FILTER,
    filter
  }
}